var lib_geometry = require("lib-geometry");
var colors = require("./../../colors/colors.js");

var SnapView = function (editorView, model, layer) {
    var self = this;

    this.editorView = editorView;
    this.model = model;

    this.snapGroup = this.editorView.layers.get(layer).svgGroup;

    this.model.cameraModel.viewS.onChange({}, function() {
        self.editorView.heavyHandler.scheduleHeavy('zoom_snap', self.drawSnap, self, [self.model.snap_info()], self);
    },10);

    this.model.snap_info.onChange('measure', function(){
        self.drawSnap(self.model.snap_info());
    },10);
};

module.exports = SnapView;

/*SnapView.prototype.snapPoint = function(point) {
    var self = this;

    $(self.snapGroup).empty();

    this.snapFrom = new SnapSet();
    this.snapFrom.add(point,1);

    var snap_info = this.snapFrom.trySnapTo(this.snapTo,4 / this.cameraModel.viewS());

    if (snap_info) {
        self.snap_vec = snap_info.vec;
        self.drawSnap(snap_info);
    } else {
        self.snap_vec = new lib_geometry.Coord(0,0);
    }

    return point.add(self.snap_vec);
};*/

SnapView.prototype.drawSnap = function(snap_info) {
    var self = this;

    self.clearSnap();

    if (!snap_info) {
        return;
    }

    var from = snap_info.from.obj;
    var to = snap_info.to.obj;

    if (((from.constructor === lib_geometry.Line)||(from.constructor === lib_geometry.Segment)) && ((to.constructor === lib_geometry.Line)||(to.constructor === lib_geometry.Segment))) {
        var obj = to.copy();
        obj.draw(self.editorView.svg, self.snapGroup, colors.snapLineStroke, 2/self.model.cameraModel.viewS(), 0.5);
    } else if ((from.constructor === lib_geometry.Coord) && ((to.constructor === lib_geometry.Line)||(to.constructor === lib_geometry.Segment))) {
        var obj = to.copy();
        obj.draw(self.editorView.svg, self.snapGroup, colors.snapLineStroke, 2/self.model.cameraModel.viewS(), 0.5);
    } else if (((from.constructor === lib_geometry.Line)||(from.constructor === lib_geometry.Segment)) && (to.constructor === lib_geometry.Coord)) {
        var obj = from.translate(snap_info.vec);
        obj.draw(self.editorView.svg,self.snapGroup, colors.snapLineStroke, 2/self.model.cameraModel.viewS(), 0.5);
    } else if ((from.constructor === lib_geometry.Coord) && (to.constructor === lib_geometry.Coord)) {
        var orig = snap_info.to.orig;
        for (var i = 0; i < orig.length; i++) {
            var obj = orig[i].copy();
            obj.draw(self.editorView.svg,self.snapGroup, colors.snapLineStroke, 2/self.model.cameraModel.viewS(), 0.5);
        }
    }

};

SnapView.prototype.clearSnap = function()
{
    $(this.snapGroup).empty();
};

